import { createRouter, createWebHistory } from 'vue-router';
import testpinia from '../components/testpinia.vue';
import Songsearch from '../components/songsearch.vue';
import StarSongs from '../components/StarSongs.vue';
import SongList from '../components/SongList.vue';
import carousel from '../components/carousel.vue';
import Featuredsongs from '../components/featuredsongs.vue';
import addmyfavorite from '../components/addmyfavorite.vue';
import editmyfavorite from '../components/editmyfavorite.vue';
import recharge from '../components/recharge.vue';
import setup from '../components/setup.vue';
import login from '../components/login.vue';
import NotFoundComponent from '../components/NotFoundComponent.vue';
// import PlayerComponent from '../components/PlayerComponent.vue';
import { useUserStore } from '@/store/useUserStore';
import Playerhc from '../components/Playerhc.vue';
import { useUserStore as useUserStoreInComponents } from '../stores/userStore';
import PaymentCallback from '../components/PaymentCallback.vue';  
import EcpayRedirect from '../components/EcpayRedirect.vue';

const routes = [
  { path: '/', component: Songsearch },
  { path: '/login', name: 'login', component: login },
  { path: '/addmyfavorite', name: 'addmyfavorite', component: addmyfavorite },
  { path: '/editmyfavorite', name: 'editmyfavorite', component: editmyfavorite },
  { path: '/recharge', name: 'Recharge', component: () => import('../components/recharge.vue'), meta: { requiresAuth: false } },
  { path: '/setup', name: 'setup', component: setup },
  { path: '/carousel', name: 'carousel', component: carousel },
  { path: '/testpinia', name: 'testpinia', component: testpinia },
  { 
    path: '/songsearch', 
    name: 'songsearch', 
    component: Songsearch
  },
  { path: '/StarSongs', name: 'StarSongs', component: StarSongs, props: (route) => ({ param1: route.query.param1, param2: route.query.param2 }) },
  { path: '/SongList', name: 'SongList', component: SongList, props: (route) => ({ param1: route.query.param1, param2: route.query.param2 }) },
  { 
    path: '/featuredsongs', 
    name: 'featuredsongs', 
    component: Featuredsongs, 
    props: (route) => ({ 
      param: route.query.param1 && route.query.param2 ? route.query.param1 + route.query.param2 : 'AA'
    })
  },
  { path: '/featuredsongs/:param', name: 'Featuredsongs', component: Featuredsongs, props: true },
  { path: '/player', name: 'player', component: Playerhc },
  { path: '/:catchAll(.*)', name: 'Songsearch', component: Songsearch },
  {
    path: '/payment-callback',
    name: 'PaymentCallback',
    component: PaymentCallback
  },
  {
    path: '/payment/ecpay',
    name: 'EcpayRedirect',
    component: EcpayRedirect
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由守衛
router.beforeEach((to, from, next) => {
  const userStore = useUserStoreInComponents();
  
  // 檢查路由是否需要認證
  if (to.meta.requiresAuth && !userStore.isAuthenticated) {
    // 未登入，重定向到登入頁面
    next({ name: 'Login' });
  } else {
    // 繼續導航
    next();
  }
});

export default router;
